import _ from 'lodash'
import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'
import importModalTemplateUrl from './importModal.html'
import exportModalTemplateUrl from './exportModal.html'

/**
 * @type {ngComponent}
 */
export const tmrAdminOperationConfigurationForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminOperationConfigurationFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * @type {ngController}
 */
export class tmrAdminOperationConfigurationFormController extends tmrResourceFormController {
  defaultKeys = [
    'tmr.operation.config.inbound.mode',
    'tmr.operation.config.outbound.mode',
    'tmr.operation.config.reading.mode',
    'tmr.operation.config.enableRfidCheck',
    'tmr.operation.config.itemvalidation',
    'tmr.operation.config.missing.confirm',
    'tmr.operation.config.overqty.confirm',
    'tmr.operation.config.unexpected.confirm',
    'tmr.operation.config.readings.displayMode',
    'tmr.operation.config.remove.mode',
    'tmr.operation.config.checklist.autocreate',
    'tmr.operation.config.createChecklistType',
    'tmr.operation.config.unknownItemsAction',
    'tmr.operation.config.confirmmode',
    'tmr.operation.config.hasChecklist',
    'tmr.operation.config.hideParcelInput',
    'tmr.operation.config.hideShipmentInput',
    'tmr.operation.config.hideDestinationInput',
    'tmr.operation.config.canCreateShipment',
    'tmr.operation.config.canCreateParcel',
    'tmr.logistics.encoding.identifiers.exist.validate',
    'tmr.logistics.encoding.initial.type',
    'tmr.logistics.encoding.nextepc.filter',
    'tmr.logistics.encoding.nextepc.gs1',
    'tmr.logistics.encoding.nextepc.partition',
    'tmr.logistics.encoding.productionorder.validate',
    'tmr.logistics.encoding.productionorder.worker.validate',
    'tmr.logistics.encoding.serial.productCode',
    'tmr.logistics.encoding.write.enable',
    'tmr.operation.config.item.error.states',
    'tmr.operation.config.item.warning.states',
    'tmr.operation.config.item.ignore.states',
    'tmr.operation.config.filterByOperation',
    'showListOnStart',
  ]

  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    $timeout,
    $mdDialog,
    Role,
    tmrOperationConfigurationTypes
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      $timeout,
      $mdDialog,
      Role,
      tmrOperationConfigurationTypes,
    })
  }

  $onInit() {
    super.$onInit()
    this.initCustomKeys()
  }

  /** Query to get roles for md-autocomplete */
  getRoles(value) {
    return this.Role.search({ value }).$promise
  }

  /** Remove attributes of other operation types */
  filterAttributes() {
    const inbound = ['tmr.operation.config.inbound.mode']
    const outbound = [
      'tmr.operation.config.outbound.mode',
    ]
    const inboundOutbound = [
      'tmr.operation.config.reading.mode',
      'tmr.operation.config.enableRfidCheck',
      'tmr.operation.config.itemvalidation',
      'tmr.operation.config.checklist.autocreate',
      'tmr.operation.config.createChecklistType',
      'tmr.operation.config.missing.confirm',
      'tmr.operation.config.overqty.confirm',
      'tmr.operation.config.unexpected.confirm',
      'tmr.operation.config.readings.displayMode',
      'tmr.operation.config.remove.mode',
      'tmr.operation.config.hasChecklist',
      'tmr.operation.config.unknownItemsAction',
      'tmr.operation.config.confirmmode',
      'tmr.operation.config.hideParcelInput',
      'tmr.operation.config.hideShipmentInput',
      'tmr.operation.config.hideDestinationInput',
      'tmr.operation.config.canCreateShipment',
      'tmr.operation.config.canCreateParcel',
      'tmr.operation.config.item.error.states',
      'tmr.operation.config.item.warning.states',
      'tmr.operation.config.item.ignore.states',
      'tmr.operation.config.filterByOperation',
      'showListOnStart',
    ]
    const encoding = [
      'tmr.logistics.encoding.identifiers.exist.validate',
      'tmr.logistics.encoding.initial.type',
      'tmr.logistics.encoding.nextepc.filter',
      'tmr.logistics.encoding.nextepc.gs1',
      'tmr.logistics.encoding.nextepc.partition',
      'tmr.logistics.encoding.productionorder.validate',
      'tmr.logistics.encoding.productionorder.worker.validate',
      'tmr.logistics.encoding.serial.productCode',
      'tmr.logistics.encoding.write.enable',
    ]
    if (this.resource.operationType === 'INBOUND') {
      outbound.forEach(key => delete this.resource.attributes[key])
      encoding.forEach(key => delete this.resource.attributes[key])
    } else if (this.resource.operationType === 'OUTBOUND') {
      inbound.forEach(key => delete this.resource.attributes[key])
      encoding.forEach(key => delete this.resource.attributes[key])
    } else if (this.resource.operationType === 'ENCODING') {
      outbound.forEach(key => delete this.resource.attributes[key])
      inbound.forEach(key => delete this.resource.attributes[key])
      inboundOutbound.forEach(key => delete this.resource.attributes[key])
    }
  }

  save() {
    this.filterAttributes()

    // Convert role data to string (Role.search in getRoles converted it to object before)
    if (typeof this.resource.role.data === 'object')
      this.resource.role.data = JSON.stringify(this.resource.role.data)
    return super.save()
  }

  initCustomKeys() {
    this.customKeys = this.resource.attributes
      ? Object.keys(this.resource.attributes).filter(
          key => !this.defaultKeys.includes(key)
        )
      : []
    this.customKeyCtrls = {}
  }

  addCustomKey() {
    this.customKeys.push(this.customKey)
    this.customKeySubform.$setUntouched()
    this.$timeout(() => {
      this.customKeyCtrls[this.customKey].dialog()
      this.customKey = null
    })
  }

  deleteCustomKey(key) {
    delete this.resource.attributes[key]
    delete this.customKeyCtrls[key]
    this.customKeys.splice(
      this.customKeys.findIndex(k => k === key),
      1
    )
  }

  onOperationTypeChange() {
    if (this.op !== 'add') return
    if (this.resource.operationType == 'INBOUND') {
      this.resource.attributes['tmr.operation.config.hasChecklist'] = 'yes'
      this.resource.attributes['tmr.operation.config.checklist.autocreate'] = 'no'
      this.resource.attributes['tmr.operation.config.filterByOperation'] = 'no'
      this.resource.attributes['tmr.operation.config.canCreateParcel'] = 'no'
      this.resource.attributes['tmr.operation.config.canCreateShipment'] = 'no'
    } else if (this.resource.operationType == 'OUTBOUND') {
      this.resource.attributes['tmr.operation.config.hasChecklist'] = 'no'
      this.resource.attributes['tmr.operation.config.checklist.autocreate'] = 'yes'
      this.resource.attributes['tmr.operation.config.filterByOperation'] = 'yes'
      this.resource.attributes['tmr.operation.config.canCreateParcel'] = 'yes'
      this.resource.attributes['tmr.operation.config.canCreateShipment'] = 'yes'
    }
  }

  importModal() {
    this.$mdDialog
      .show({
        templateUrl: importModalTemplateUrl,
        controller: function ($mdDialog, TmrToast) {
          'ngInject'
          this.$mdDialog = $mdDialog
          this.onImport = function () {
            let json
            try {
              json = JSON.parse(this.import)
              if (!_.isPlainObject(json)) throw new Error()
            } catch (err) {
              json = null
              TmrToast.error('ADMIN.OPERATIONCONFIGURATIONS.FORM.INVALIDJSON')
            }
            if (json) $mdDialog.hide(json)
          }
        },
        bindToController: true,
        controllerAs: '$ctrl',
        clickOutsideToClose: true,
        fullscreen: true,
      })
      .then(json => {
        this.resource.attributes = json
        this.initCustomKeys()
        this.customKeySubform.$setUntouched()
      })
  }

  exportModal() {
    this.filterAttributes()

    this.$mdDialog.show({
      templateUrl: exportModalTemplateUrl,
      controller: function ($mdDialog) {
        'ngInject'
        this.$mdDialog = $mdDialog
      },
      bindToController: true,
      controllerAs: '$ctrl',
      clickOutsideToClose: true,
      fullscreen: true,
      locals: {
        export: JSON.stringify(this.resource.attributes, null, 2),
      },
    })
  }

  suggestedClients() {
    if (this.resource.operationType === 'ENCODING') {
      return ['station', 'reports']
    }
    return ['mobile', 'station', 'reports']
  }
}
